/**
 * El mensaje de un error del api, SIEMPRE como texto.
 *
 * `response.data.error` no siempre es una cadena: hay rutas que devuelven el objeto entero
 * (`{message, code, stack}`). Pasarlo tal cual a un `<p>` o a un toast revienta React con
 * «Objects are not valid as a React child» y tumba la pantalla completa — el asesor pierde el
 * trabajo en curso por un error que solo había que enseñarle.
 *
 * Se descubrió al dejar de tragar los fallos del asistente de migración: mientras se
 * ignoraban en silencio, la forma del campo daba igual.
 */
export function mensajeDeError(e, porDefecto = 'Algo salió mal') {
  const err = e?.response?.data?.error;
  if (typeof err === 'string' && err.trim()) return err;
  if (err && typeof err === 'object' && typeof err.message === 'string') return err.message;
  if (typeof e?.message === 'string' && e.message.trim()) return e.message;
  return porDefecto;
}

/** Lo mismo para un valor suelto que ya venga de la respuesta (no el error de axios). */
export function comoTexto(valor, porDefecto = '') {
  if (typeof valor === 'string') return valor;
  if (valor && typeof valor === 'object' && typeof valor.message === 'string') return valor.message;
  return porDefecto;
}

export default mensajeDeError;
